import { Component, OnInit, Inject, Input } from "@angular/core";
import { Router } from "@angular/router";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { CryptographyService } from "../services/cryptography.service";

import { AddendumService } from "../services/addendum.service";

import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SuccessDialogComponent } from "../success-dialog/success-dialog.component";
import { AdminService } from "../services/admin.service";
import { Country } from "../models/country";
import { FailModuleComponent } from "../fail-module/fail-module.component";
import { AOWGroup } from "../models/aowgroup";

import { UserRoleEnum } from "../core/constant";
@Component({
  selector: "app-impersonate-exit",
  templateUrl: "./impersonate-exit.component.html",
  styleUrls: ["./impersonate-exit.component.scss"],
})
export class ImpersonateExitComponent {
  selectedCountryID: any;
  loading: boolean = false;
  countries: Country[] = [];
  selectedRole: string = "";
  role: number;
  error: string = "";
  aowGroups: AOWGroup[] = [];
  selectedAOWgrp: number;
  viewRole: string = "";


  constructor(
    private adminService: AdminService,
    private addendumService: AddendumService,
    private router: Router,
    @Inject(LOCAL_STORAGE)
    public storage: WebStorageService,
    private cryptographyService: CryptographyService,
    private ngbModal: NgbModal
  ) {}

  ngOnInit() {
    this.viewRole =
      UserRoleEnum[
        this.cryptographyService.decryptData(sessionStorage.getItem("userRoleId"))
      ];
  }

  onExit() {
    sessionStorage.clear()
    this.router.navigate(["/locations"]).then(()=>{

      window.location.reload();
    });
    sessionStorage.setItem("userExit", "true");
    // this.loading = true;
    // const payload = {
    //   Id: this.cryptographyService.decryptData(this.storage.get("userId")),
    //   UserRoleId: 1,
    //   Email: this.cryptographyService.decryptData(this.storage.get("email")),
    //   countryId: this.cryptographyService.decryptData(
    //     this.storage.get("countryId")
    //   ),
    //   AOWGroupId: this.selectedRole == "AOW Admin" ? this.selectedAOWgrp : null,
    // };
    // this.adminService.UpdateUserRole(payload).subscribe((data) => {
    //   if (data) {
    //     this.loading = false;
    //     this.router.navigate(["/locations"]).then(() => {
    //       sessionStorage.removeItem("impersonationView");
    //       sessionStorage.removeItem("impersonationReloaded");
    //       sessionStorage.removeItem("impersonationDialogShown");
    //       sessionStorage.setItem("userExit", "true");
    //       // localStorage.setItem("isImpersonated", "false")
    //       // localStorage.removeItem("userExit")
    //       // this.storage.set("isImpersonated", false)

    //       window.location.reload();
    //     });
    //     //      const modalRef = this.ngbModal.open(SuccessDialogComponent);
    //     //     modalRef.componentInstance.message = "You have exit the role. Please Refresh to view as Global Admin";
    //     //     modalRef.componentInstance.nrbesSuccessPopupEmit.subscribe(() => {
    //     //         this.ngbModal.dismissAll();
    //     //     })
    //     //      modalRef.result
    //     //   .finally(() => {
    //     //       this.router.navigate(['/locations']).then(() => {
    //     //      window.location.reload()
    //     //     localStorage.removeItem("impersonationView");
    //     //     localStorage.removeItem("impersonationReloaded");
    //     //     localStorage.removeItem("impersonationDialogShown")

    //     //   })
    //     // });
    //     //   this.router.navigate(['/locations']).then(() => {
    //     //    window.location.reload()
    //     //   localStorage.removeItem("impersonationView");
    //     //   localStorage.removeItem("impersonationReloaded");
    //     //   localStorage.removeItem("impersonationDialogShown");
    //     // });
    //   }
    //   (error: string) => {
    //     this.error = error;
    //     const modalRef = this.ngbModal.open(FailModuleComponent);
    //     this.error = error;
    //     modalRef.componentInstance.errorMessage = error;
    //     this.loading = false;
    //   };
    // });
  }
}
